<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>展厅</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row flex-row-reverse">
		            <div class="col-lg-9">
		                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
		                    <div class="col mb-6" v-for="(item,index) in showList" :key="item.id">
		                        <div class="blog-wrap">
		                            <div class="blog-img mb-2">
										<router-link :to="{path:'/showDetail/'+item.id}" class="thumbnail">
										    <img :src="item.image | imgfilter" alt="Blog Image">
										</router-link>
		                            </div>
									<div class="blog-content d-flex">
										<div style="flex: 1;">
											<div>
												<router-link :to="{path:'/showDetail/'+item.id}" class="thumbnail">
													<div>{{item.name}}</div>
												</router-link>
											</div>
											<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
										</div>
										<div class="collent">
											<Icon v-if="item.isLike" style="cursor: pointer;" size="30" type="ios-heart" color="#ff495e" @click="collect(item)" />
											<Icon v-else style="cursor: pointer;" size="30" type="ios-heart-outline" @click="collect(item)" />
											<div>{{item.like_count}}</div>
										</div>
									</div>
									<!-- <div class="avatar-div">
										<img class="avatar-img" :src="item.publishInfo.avatar | imgfilter" >
										<span class="avatar-name">{{item.publishInfo.nickname}}</span>
									</div> -->
		                        </div>
		                    </div>
		                </div>
		                <div class="pagination-style mt-3">
		                    <div class="block">
		                        <el-pagination
		                          @current-change="handleCurrentChange"
		                          :pager-count="5"
		                          :current-page="currentPage"
		                          layout="total, prev, pager, next"
		                          :total="total">
		                        </el-pagination>
		                    </div>
		                </div>
		            </div>
		            <div class="col-lg-3">
		                <div class="sidebar-wrap sidebar-margin-right">
		                    <div class="sidebar-widget">
		                        <h3 class="sidebar-widget-title">全部分类</h3>
		                        <div class="sidebar-categori">
									<el-menu default-active="2" unique-opened text-color="#666666" active-text-color='#009C44' class="el-menu-vertical-demo" @select="handleSelect">
									  <el-submenu :index="menu.id.toString()" v-for="(menu,index) in cateList" :key="menu.id">
										<template slot="title"><span>{{menu.cate_name}}</span></template>
										  <el-menu-item :index="child.id.toString()" v-for="(child,cindex) in menu.children" :key="child.id">{{child.cate_name}}</el-menu-item>
									  </el-submenu>
									</el-menu>
		                        </div> 
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		getCategoryList,
		getShowList,
		ShowLikeAdd,
		ShowLikeDel
	 } from '@/api'
	 export default {
	   data() {
			return {
				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				cateList: [],
				showList: [],
				total: 0,
				currentPage: 1,
				pid: 0,
			}
		},
		created() {
			this.getCategoryList()
		    this.getShowList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			// 获取板块分类列表
			async getCategoryList() {
			  const res = await getCategoryList()
			  this.cateList = res.data
			},
			
			// 获取展厅详情
			async getShowList() {
			  const res = await getShowList({
				  pid: this.pid,
				  page: this.currentPage,
				  limit: 10
			  })
			  console.log(res)
			  res.data.list.forEach(e => {
				  if(e.tags) e.tags = e.tags.split(',') || []
			  })
			  this.total = res.data.count
			  this.showList = res.data.list
			},
			
			// 页数跳转
			handleCurrentChange(val) {
				this.currentPage = val
				this.getShowList()
				document.documentElement .scrollTop= 0
			},
			
			// 专栏分类选择
			handleSelect(key, keyPath) {
				this.pid = key || 0
				this.currentPage = 1
				this.getShowList()
				document.documentElement .scrollTop= 0
			},
			
			collect(item){
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if(item.isLike == 0){
					ShowLikeAdd({
						show_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 1
							item.like_count++
						}
					})
				}else{
					ShowLikeDel({
						show_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.isLike= 0
							item.like_count--
						}
					})
				}
			},
		}
	}
</script>

<style>
</style>
